import React, { PropTypes } from 'react';
import LoadingSpinner from '../../../LoadingSpinner';
import { Container } from 'react-grid-system'
import LoggedAppBar from '../../../LoggedLayout/LoggedAppBar';
import { CardHeader } from 'material-ui/Card';
import Card from 'material-ui/Card';
import { CardTitle } from 'material-ui/Card';
import { CardText } from 'material-ui/Card';
import InputCheckbox from '../../../form/InputCheckbox';
import { CardActions } from 'material-ui/Card';
import { FlatButton } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import { StreamEventStatusType } from '../../../../api/stream/LiveStadiumStreamEvent';
import IconButton from 'material-ui/IconButton';
import IconClose from '../../../Icons/IconClose';
import IconPlay from '../../../Icons/IconPlay';
import HLSPlayer from '../../../HLSPlayer';
import ConfirmMessage from '../../../ConfirmMessage';

let refreshTimeout

class StreamView extends React.Component {
  static propTypes = {
    model: PropTypes.object,
    fetch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
  };

  state = {
    isPlaying: false,
    isDisabledControls: false,
    confirmDeleteIsOpen: false
  }
  
  toggleDeleteModal = () => {
    this.setState(({confirmDeleteIsOpen}) => ({ confirmDeleteIsOpen: !confirmDeleteIsOpen }));
  }
  
  onConfirmDeleteOpen = () => { 
    this.setState({ confirmDeleteIsOpen: true });
  }

  confirmRemoveMessage = (
    <FormattedMessage
      id="record.remove"
      defaultMessage="Are you sure you want to delete stream event?"
    />
  );

  componentDidMount() {
    this.props.fetch(this.props.params.id);
  }
  componentWillUnmount() {
    clearTimeout(refreshTimeout)
  }
  goBack = () => {
    this.props.onClose();
  };
  onDelete = async () => {
    await this.props.delete(this.props.model)
    this.props.goIndex()
  }
  onTogglePlay = () => {
    this.setState((state) => ({ isPlaying: !state.isPlaying }))
  }
  componentWillReceiveProps(newProps) {
    if (!newProps.loading && buttonIsDisabled(newProps.model.channel_state)) {
      setTimeout(this.onRefreshTimeout, 5000)
    }
    this.setState({
      isDisabledControls: buttonIsDisabled(newProps.model.channel_state)
    })
  }
  // componentDidReceiveProps(nextProps) {
  //   const { model } = nextProps
  //   console.log(model.channel_state, this.props.model.channel_state)

  // }
  onRefreshTimeout = () => {
    clearTimeout(refreshTimeout)
    let { model, fetch } = this.props;
    fetch(model.id)
    
  }
  onToggleMediaServer = async () => {
    let { model, fetch } = this.props;
    if (buttonIsDisabled(model.channel_state)) {
      // this.onRefreshTimeout()
      fetch(model.id)
      return
    }
    // return
    this.setState({
      isDisabledControls: true
    })
    model.toggleMediaServer(!model.rtmp_url).then(async () => {
      fetch(model.id)
    }).catch(() => {
      this.setState({
        isDisabledControls: false
      })
      fetch(model.id)
    })
    // this.setState({ dialogAction: () => { }, dialogLabel: 'Te media server will be started' })
  }
  render() {
    
    let { loading, loadingItem, model, title: pageTitle, goEdit } = this.props;

    const { isPlaying, isDisabledControls } = this.state

    const {
      
      title,
      startDate,
      endDate,
      logo,
      channel_state,
      vip_only,
      description,
      rtmp_url,
      m3u8
    } = model || {}
    
    const startDateDate = new Date(startDate)
    const endDateDate = new Date(endDate)

    

    return <div>
      <LoggedAppBar
        title={pageTitle}
        isStatic={true}
        iconElementRight={
          <IconButton onClick={this.goBack}>
            <IconClose />
          </IconButton>
        }
      >
      </LoggedAppBar>
      <LoadingSpinner show={loading || loadingItem} overlay={ !!logo }>
        <Container style={{ marginLeft: 0, padding: 0 }}>
          <Card style={{ maxWidth: 640, padding: '16px', margin: '16px'}}>
            <CardHeader
              style={{width: '100%', padding: 0 }}
              avatar={!!logo && <div onClick={isPlaying ? undefined : this.onTogglePlay} style={{
                padding: 0, 'position': 'relative', flex: 1, margin: 0, cursor: isPlaying ? 'initial' : 'pointer'
              }}>
                <img style={{ width: 608, height: 377 }} src={logo.small} />
                {!!m3u8 && isPlaying && <div style={{
                  width: '100%', height: '100%', position: 'absolute', left: '0', top: '0', zIndex: 20, display: 'flex', alignItems: 'center', backgroundColor: 'black'
                }}><HLSPlayer height={'100%'} controls autoPlay value={{ url: m3u8 }} /></div>}
                {!!m3u8 && <IconPlay style={{ height: '64px',
    width: '64px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10, filter: 'invert(1)', padding: '20px', backgroundColor: 'rgba(255,255,255,0.3)', borderRadius: 8, boxSizing: 'border-box' }}  />}
              </div>}
            >
              <CardTitle
                style={{padding: 0}}
                title={<div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                  <span>{title}</span>
                  <span style={{ fontSize: 15 }}>server status: <b style={{ marginLeft: '2px', borderRadius: '3px', padding: '2px 6px', backgroundColor: bgColor(channel_state), color: 'white'}}>{channel_state}</b></span>
                </div>}
                titleStyle={{ fontSize: '36px' }}
                subtitleStyle={{ fontSize: '12px' }}
                subtitle={<div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                  <span>{startDateDate.toLocaleDateString()} {startDateDate.toLocaleTimeString()} - {endDateDate.toLocaleDateString()} {endDateDate.toLocaleTimeString()}`</span>
                  <FlatButton disabled={loading || isDisabledControls} style={{
                    padding: '0 24px',
                    marginTop: '4px',
                    fontWeight: 'bold',
                    fontSize: 15,
                  color: 'white',
                  backgroundColor: buttonColor(channel_state, isDisabledControls),
                  }} onClick={(e) => { this.onToggleMediaServer(); e.preventDefault() }}>{buttonTitle(channel_state, isDisabledControls)}</FlatButton>
                </div>}
              />
            </CardHeader>
            <CardText style={{ padding: 0 }}>
              <div style={{backgroundColor: 'rgba(0,0,0,0.05)', padding: '1px 8px', marginTop: '16px', marginBottom: '16px'}} dangerouslySetInnerHTML={{ __html: description }}></div>
              <p style={{ display: 'flex' }}>rtmp_url: <textarea
                rows={1}
                style={{ fontSize: 14, fontFamily: '"Open Sans", sans-serif', flex: 1, border: 0, backgroundColor: 'transparent', outline: 'none', marginLeft: '6px', padding: 0 }}
                value={rtmp_url || 'Media server is not ready...'}
                readOnly={true} /></p>
              <p style={{ paddingTop: 0, display: 'flex', flexDirection: 'column' }}>m3u8: {  !!!m3u8 ? 'Source is not ready... Please start rtmp-translation&' : ''}<textarea
                rows={3}
                style={{ marginTop: '6px', fontSize: 14, fontFamily: '"Open Sans", sans-serif', flex: 1, border: 0, backgroundColor: 'transparent', outline: 'none', marginLeft: '6px', padding: 0 }}
                value={m3u8}
                readOnly={true} /></p>
            </CardText>
            <CardActions style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              padding: 0
            }}>
              <InputCheckbox
                style={{ cursor: 'initial', padding: 0, width: '200px' }}
                label={'VIP-only'}
                value={vip_only}
                disabled={true}
                labelPosition='right'
                onChange={() => { }}
              />
              <div>
                <FlatButton disabled={loading} style={{
                  padding: '0 24px',
                  backgroundColor: 'none',
                  marginRight: '24px'
                }} onClick={() => goEdit(this.props.params.id)}>Edit</FlatButton>
                <FlatButton disabled={loading} style={{
                  padding: '0 24px',
                  backgroundColor: 'none',
                  }} onClick={() => this.toggleDeleteModal()}>Delete</FlatButton>
              </div>
              </CardActions>
          </Card>
          
        </Container>
      </LoadingSpinner>
      <ConfirmMessage open={this.state.confirmDeleteIsOpen}
        label={this.confirmRemoveMessage}
        onConfirm={() => this.onDelete(this.props.params.id)}
        onClose={() => this.toggleDeleteModal()}/>
    </div>
  }

}


const buttonIsDisabled = (type) => {
  switch (type) {
    case StreamEventStatusType[StreamEventStatusType.CREATE_FAILED]:
    case StreamEventStatusType[StreamEventStatusType.OFF]:
    case StreamEventStatusType[StreamEventStatusType.UPDATE_FAILED]:
    // case StreamEventStatusType[StreamEventStatusType.IDLE]:
      return false
    case StreamEventStatusType[StreamEventStatusType.RUNNING]:
      return false
    default:
      return true
  }
}
const buttonColor = (type, isDisabledControls) => {
  if(isDisabledControls) return 'rgb(152 152 152)'
  switch (type) {
    case StreamEventStatusType[StreamEventStatusType.CREATE_FAILED]:
    case StreamEventStatusType[StreamEventStatusType.OFF]:
    case StreamEventStatusType[StreamEventStatusType.UPDATE_FAILED]:
    // case StreamEventStatusType[StreamEventStatusType.IDLE]:
      return 'rgb(19 96 22)'
    case StreamEventStatusType[StreamEventStatusType.RUNNING]:
      return 'rgb(152 10 10)'
    default:
      return 'rgb(152 152 152)'
  }
}
const bgColor = (type, isDisabledControls) => {
  if(isDisabledControls) return 'rgb(152 152 152)'
  switch (type) {
    case StreamEventStatusType[StreamEventStatusType.CREATE_FAILED]:
    case StreamEventStatusType[StreamEventStatusType.OFF]:
    case StreamEventStatusType[StreamEventStatusType.UPDATE_FAILED]:
    // case StreamEventStatusType[StreamEventStatusType.IDLE]:
      return 'rgb(152 10 10)'
    case StreamEventStatusType[StreamEventStatusType.RUNNING]:
      return 'rgb(19 96 22)'
    default:
      return 'rgb(152 152 152)'
  }
}

const buttonTitle = (type, isDisabledControls) => {
  if(isDisabledControls) return `media server in progress (${type})`
  switch (type) {
    case StreamEventStatusType[StreamEventStatusType.CREATE_FAILED]:
    case StreamEventStatusType[StreamEventStatusType.OFF]:
    case StreamEventStatusType[StreamEventStatusType.UPDATE_FAILED]:
    // case StreamEventStatusType[StreamEventStatusType.IDLE]:
      return 'start media server'
    case StreamEventStatusType[StreamEventStatusType.RUNNING]:
      return 'stop media server'
    // case StreamEventStatusType[StreamEventStatusType.CREATING]:
    // case StreamEventStatusType[StreamEventStatusType.DELETING]:
    // case StreamEventStatusType[StreamEventStatusType.IDLE]:
    // case StreamEventStatusType[StreamEventStatusType.RECOVERING]:
    // case StreamEventStatusType[StreamEventStatusType.RUNNING]:
    // case StreamEventStatusType[StreamEventStatusType.STARTING]:
    // case StreamEventStatusType[StreamEventStatusType.STOPPING]:
    // case StreamEventStatusType[StreamEventStatusType.UPDATING]:
    case StreamEventStatusType[StreamEventStatusType.DELETED]:
        return 'media server deleted'
    default:
      return `media server in progress (${type})`
  }
}

export default StreamView;



// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamView/StreamView.jsx